export default "static/wasm/tfjs-backend-wasm-simd.wasm";